<template>
  <div class="modellist-container">
    <el-form :model="queryInfo" size="medium" :inline="true">
          <el-form-item :label="$t('bike.name1')" prop="loginName" v-if="userinfo.tenantType === 0">
            <el-select v-model="queryInfo.tenantId" :placeholder="$t('public.name1')" clearable >
              <el-option v-for="item in tenantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('bike.name2')" prop="ebikeModelId">
            <el-input v-model="queryInfo.ebikeModelId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name48')" prop="ebikeModelName">
            <el-input v-model="queryInfo.ebikeModelName" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name49')" prop="electricalMachineryModel">
            <el-input v-model="queryInfo.electricalMachineryModel" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name152')" prop="batteryModel">
            <el-input v-model="queryInfo.batteryModel" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="getPageList">{{ $t('public.name3') }}</el-button>
            <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
          </el-form-item>
    </el-form>
    <div class="add-user">
      <el-button type="primary" size="medium" @click="showAddModelDialog(null)" v-if="buttonPerms.indexOf('ebikeModel/saveEbikeModel') > -1">{{ $t('screen.name95') }}</el-button>
      <el-button type="primary" size="medium" @click="importModelDialog(null)" v-if="buttonPerms.indexOf('ebikeModel/importEbikeModel') > -1">{{ $t('bike.name189') }}</el-button>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading='tableLoading'>
      <el-table-column :label="$t('bike.name4')" prop="ebikeModelId" sortable></el-table-column>
      <el-table-column :label="$t('bike.name5')" prop="tenantName" sortable width="170"> </el-table-column>
      <el-table-column :label="$t('bike.name52')" prop="ebikeModelName" sortable></el-table-column>
      <el-table-column :label="$t('bike.name53')" prop="modelColor" sortable></el-table-column>
      <el-table-column :label="$t('bike.name54')" prop="electricalMachineryModel" sortable></el-table-column>
      <el-table-column :label="$t('bike.name153')" prop="batteryModel" sortable></el-table-column>
      <el-table-column :label="$t('bike.name55')" prop="batteryVoltage" sortable></el-table-column>
      <!-- <el-table-column :label="$t('bike.name56')" prop="batteryCurrent" sortable></el-table-column> -->
      <el-table-column :label="$t('bike.name154')" prop="batteryCapacity" sortable></el-table-column>
      <!-- <el-table-column :label="$t('bike.name57')" prop="tire" sortable></el-table-column> -->
      <el-table-column :label="$t('bike.name155')" prop="sensor" sortable></el-table-column>
      <el-table-column :label="$t('bike.name174')" prop="controllerModel" sortable width="120"></el-table-column>
      <el-table-column :label="$t('bike.name175')" prop="controllerTemperatureShowDeviation" sortable width="170"></el-table-column>
      <el-table-column :label="$t('bike.name11')" width="160px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="showAddModelDialog(scope.row)" v-if="buttonPerms.indexOf('ebikeModel/updateEbikeModel') > -1">{{ $t('bike.name47') }}</el-button>
          <el-button type="text" @click="delModel(scope.row)" style="color:#ea4646" v-if="buttonPerms.indexOf('ebikeModel/deleteEbikeModel') > -1">{{ $t('bike.name13') }}</el-button>
          <el-button type="text" @click="showOffsetDialog(scope.row)"  v-if="buttonPerms.indexOf('eBikeModel/offSet') > -1">{{ $t('bike.name378') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
     <el-dialog class="mode-dialog"  :title="type === 1 ? $t('bike.name185') : $t('bike.name357')" :visible.sync="ebikeModelDialog" v-if="ebikeModelDialog" :close-on-click-modal ="false" :before-close="close" width="800px">
      <el-form ref="ebikeModelFormRef" label-width="300px"  :model="ebikeModeForm" :rules="ebikeModelFormRules" class="mode-form">
        <el-form-item :label="$t('bike.name2')" prop="ebikeModelId">
           <el-input v-model="ebikeModeForm.ebikeModelId" :placeholder="$t('public.name29') + 'KX202504290012'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name184')" prop="ebikeModelName">
           <el-input v-model="ebikeModeForm.ebikeModelName" :placeholder="$t('public.name29') + '公路车1号'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name358')" prop="cccCode">
           <el-input v-model="ebikeModeForm.cccCode" :placeholder="$t('public.name29') + '2025011119001230'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name183')" prop="modelColor">
           <el-input v-model="ebikeModeForm.modelColor" :placeholder="$t('public.name29') + '黑色'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name33')" prop="iotVersionNo">
           <el-input v-model="ebikeModeForm.iotVersionNo" :placeholder="$t('public.name29') + 'IOT001'" clearable> </el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('bike.name236')" prop="iotTemperatureShowDeviation">
          <el-input-number v-model="ebikeModeForm.iotTemperatureShowDeviation" :precision="0"></el-input-number>
        </el-form-item> -->
        <!-- <el-form-item :label="$t('bike.name237')" prop="iotTemperatureShowWarnDefaultValue">
          <el-input-number v-model="ebikeModeForm.iotTemperatureShowWarnDefaultValue" :precision="0"></el-input-number>
        </el-form-item> -->
        <el-form-item :label="$t('bike.name31')" prop="controllerVersion">
           <el-input v-model="ebikeModeForm.controllerVersion" :placeholder="$t('public.name29') + 'KZQ011'" clearable> </el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('bike.name239')" prop="controllerTemperatureShowDeviation">
          <el-input-number v-model="ebikeModeForm.controllerTemperatureShowDeviation" :precision="0"></el-input-number>
        </el-form-item> -->
        <!-- <el-form-item :label="$t('bike.name240')" prop="controllerTemperatureShowWarnDefaultValue">
          <el-input-number v-model="ebikeModeForm.controllerTemperatureShowWarnDefaultValue" :precision="0"></el-input-number>
        </el-form-item> -->
        <el-form-item :label="$t('bike.name241')" prop="batteryVersion">
           <el-input v-model="ebikeModeForm.batteryVersion" :placeholder="$t('public.name29') + 'DC011'" clearable> </el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('bike.name243')" prop="batteryTemperatureShowDeviation">
          <el-input-number v-model="ebikeModeForm.batteryTemperatureShowDeviation" :precision="0"></el-input-number>
        </el-form-item> -->
        <!-- <el-form-item :label="$t('bike.name244')" prop="batteryTemperatureShowWarnDefaultValue">
          <el-input-number v-model="ebikeModeForm.batteryTemperatureShowWarnDefaultValue" :precision="0"></el-input-number>
        </el-form-item> -->
        <el-form-item :label="$t('bike.name245')" prop="motorVersion">
           <el-input v-model="ebikeModeForm.motorVersion" :placeholder="$t('public.name29') + 'DJ011'" clearable> </el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('bike.name247')" prop="motorTemperatureShowDeviation">
          <el-input-number v-model="ebikeModeForm.motorTemperatureShowDeviation" :precision="0"></el-input-number>
        </el-form-item> -->
        <!-- <el-form-item :label="$t('bike.name248')" prop="motorTemperatureShowWarnDefaultValue">
          <el-input-number v-model="ebikeModeForm.motorTemperatureShowWarnDefaultValue" :precision="0"></el-input-number>
        </el-form-item> -->
        <el-form-item :label="$t('bike.name250')" prop="meterVersion">
           <el-input v-model="ebikeModeForm.meterVersion" :placeholder="$t('public.name29') + 'YB001'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name315')" prop="certificateExpireDate">
           <el-input v-model="ebikeModeForm.certificateExpireDate" :placeholder="$t('public.name29') + '2027/1/26'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name366')" prop="productModel">
           <el-input v-model="ebikeModeForm.productModel" :placeholder="$t('public.name29') + 'LL123421'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name316')" prop="productCertificateNumber">
           <el-input v-model="ebikeModeForm.productCertificateNumber" :placeholder="$t('public.name29') + 'A149878RS11000000'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name359')" prop="certificateStatus">
           <el-input v-model="ebikeModeForm.certificateStatus" :placeholder="$t('public.name29') + '有效'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name317')" prop="ebikeManufacturer">
           <el-input v-model="ebikeModeForm.ebikeManufacturer" :placeholder="$t('public.name29') + 'XXX车辆制造商公司'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name318')" prop="manufactureEnterpriseName">
           <el-input v-model="ebikeModeForm.manufactureEnterpriseName" :placeholder="$t('public.name29') + 'XXX生产企业公司'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name319')" prop="ebikeCnBrand">
           <el-input v-model="ebikeModeForm.ebikeCnBrand" :placeholder="$t('public.name29') + '不适用'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name320')" prop="ebikeEnBrand">
           <el-input v-model="ebikeModeForm.ebikeEnBrand" :placeholder="$t('public.name29') + 'leadeercloud'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name321')" prop="manufactureEnterpriseAddress">
           <el-input v-model="ebikeModeForm.manufactureEnterpriseAddress" :placeholder="$t('public.name29') + 'XX省XX市XX区XX街道'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name360')" prop="lengthValue">
           <el-input v-model="ebikeModeForm.lengthValue" :placeholder="$t('public.name29') + '1260'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name361')" prop="widthValue">
           <el-input v-model="ebikeModeForm.widthValue" :placeholder="$t('public.name29') + '540'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name362')" prop="heightValue">
           <el-input v-model="ebikeModeForm.heightValue" :placeholder="$t('public.name29') + '1056'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name323')" prop="ebikeWeight">
           <el-input v-model="ebikeModeForm.ebikeWeight" :placeholder="$t('public.name29') + '20'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name324')" prop="maxDesignSpeed">
           <el-input v-model="ebikeModeForm.maxDesignSpeed" :placeholder="$t('public.name29') + '25'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name325')" prop="nameplateFixedPosition">
           <el-input v-model="ebikeModeForm.nameplateFixedPosition" :placeholder="$t('public.name29') + '铆接在车架下管前部'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name326')" prop="ebikeFrameCodePosition">
           <el-input v-model="ebikeModeForm.ebikeFrameCodePosition" :placeholder="$t('public.name29') + '字高：6mm字深0.2mm 分上下两排，刻印在车架上。'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name327')" prop="enduranceMileage">
           <el-input v-model="ebikeModeForm.enduranceMileage" :placeholder="$t('public.name29') + '40'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name328')" prop="ebikeOutlinePicName">
           <el-input v-model="ebikeModeForm.ebikeOutlinePicName" :placeholder="$t('public.name29') + '公路车'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name329')" prop="batteryType">
           <el-input v-model="ebikeModeForm.batteryType" :placeholder="$t('public.name29') + '锂电'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name330')" prop="batteryManufactureEnterpriseName">
           <el-input v-model="ebikeModeForm.batteryManufactureEnterpriseName" :placeholder="$t('public.name29') + 'XXX电池生产公司'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name331')" prop="batteryCapacity">
           <el-input v-model="ebikeModeForm.batteryCapacity" :placeholder="$t('public.name29') + '10.4'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name332')" prop="batteryModel">
           <el-input v-model="ebikeModeForm.batteryModel" :placeholder="$t('public.name29') + '10S4P'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name180')" prop="batteryVoltage">
           <el-input v-model="ebikeModeForm.batteryVoltage" :placeholder="$t('public.name29') + '36V'" clearable> </el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('bike.name179')" prop="batteryCurrent">
           <el-input v-model="ebikeModeForm.batteryCurrent" :placeholder="$t('public.name29') + '10A'" clearable> </el-input>
        </el-form-item> -->
        <el-form-item :label="$t('bike.name333')" prop="batteryWeight">
           <el-input v-model="ebikeModeForm.batteryWeight" :placeholder="$t('public.name29') + '2.5±0.5'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name363')" prop="batteryLength">
           <el-input v-model="ebikeModeForm.batteryLength" :placeholder="$t('public.name29') + '257'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name364')" prop="batteryWidth ">
           <el-input v-model="ebikeModeForm.batteryWidth" :placeholder="$t('public.name29') + '78'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name365')" prop="batteryHeight">
           <el-input v-model="ebikeModeForm.batteryHeight" :placeholder="$t('public.name29') + '94'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name335')" prop="beforeAfterWheelDistance">
           <el-input v-model="ebikeModeForm.beforeAfterWheelDistance" :placeholder="$t('public.name29') + '910'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name336')" prop="driveType">
           <el-input v-model="ebikeModeForm.driveType" :placeholder="$t('public.name29') + '电驱动和电助动'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name337')" prop="hundredKmPowerConsumption">
           <el-input v-model="ebikeModeForm.hundredKmPowerConsumption" :placeholder="$t('public.name29') + '480Wh'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name338')" prop="motorManufactureEnterprise">
           <el-input v-model="ebikeModeForm.motorManufactureEnterprise" :placeholder="$t('public.name29') + 'XXX电机公司'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name339')" prop="electricalMachineryModel">
           <el-input v-model="ebikeModeForm.electricalMachineryModel" :placeholder="$t('public.name29') + 'JNW90-14'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name340')" prop="motorType">
           <el-input v-model="ebikeModeForm.motorType" :placeholder="$t('public.name29') + '永磁'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name341')" prop="motorRatedSpeed">
           <el-input v-model="ebikeModeForm.motorRatedSpeed" :placeholder="$t('public.name29') + '420±10'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name342')" prop="motorRatedVoltage">
           <el-input v-model="ebikeModeForm.motorRatedVoltage" :placeholder="$t('public.name29') + '36'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name343')" prop="motorRatedOutputPower">
           <el-input v-model="ebikeModeForm.motorRatedOutputPower" :placeholder="$t('public.name29') + '250'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name344')" prop="controllerManufactureEnterprise">
           <el-input v-model="ebikeModeForm.controllerManufactureEnterprise" :placeholder="$t('public.name29') + '南京科桥电气有限公司'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name345')" prop="controllerModel">
           <el-input v-model="ebikeModeForm.controllerModel" :placeholder="$t('public.name29') + '90B'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name346')" prop="controllerUndervoltageProtectionValue">
           <el-input v-model="ebikeModeForm.controllerUndervoltageProtectionValue" :placeholder="$t('public.name29') + '30.0±1'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name347')" prop="controllerOvercurrentProtectionValue">
           <el-input v-model="ebikeModeForm.controllerOvercurrentProtectionValue" :placeholder="$t('public.name29') + '15.0±1'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name348')" prop="frontTireSpecifications">
           <el-input v-model="ebikeModeForm.frontTireSpecifications" :placeholder="$t('public.name29') + '26*1.95'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name349')" prop="rearTireSpecifications">
           <el-input v-model="ebikeModeForm.rearTireSpecifications" :placeholder="$t('public.name29') + '26*1.95'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name350')" prop="executiveStandardNumber">
           <el-input v-model="ebikeModeForm.executiveStandardNumber" :placeholder="$t('public.name29') + 'GB 17761-2018'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name351')" prop="deadweightCapacity">
           <el-input v-model="ebikeModeForm.deadweightCapacity" :placeholder="$t('public.name29') + '150'" clearable> </el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('bike.name352')" prop="batteryNominalVoltage">
           <el-input v-model="ebikeModeForm.batteryNominalVoltage" :placeholder="$t('public.name29') + '50V'" clearable> </el-input>
        </el-form-item> -->
        <!-- <el-form-item :label="$t('bike.name353')" prop="motorNominalPower">
           <el-input v-model="ebikeModeForm.motorNominalPower" :placeholder="$t('public.name29') + '10W'" clearable> </el-input>
        </el-form-item> -->
        <el-form-item :label="$t('bike.name354')" prop="brakeType">
           <el-input v-model="ebikeModeForm.brakeType" :placeholder="$t('public.name29') + '碟刹'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name355')" prop="transmissionSpecifications">
           <el-input v-model="ebikeModeForm.transmissionSpecifications" :placeholder="$t('public.name29') + 'TX32'" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name356')" prop="iotManufactureEnterprise">
           <el-input v-model="ebikeModeForm.iotManufactureEnterprise" :placeholder="$t('public.name29') + '南京溧水电子研究所有限公司'" clearable> </el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('bike.name177')" prop="tire">
           <el-input v-model="ebikeModeForm.tire" :placeholder="$t('public.name5')" clearable> </el-input>
        </el-form-item> -->
        <el-form-item :label="$t('bike.name176')" prop="sensor">
           <el-input v-model="ebikeModeForm.sensor" :placeholder="$t('public.name29') + '中轴力矩传感器'" clearable> </el-input>
        </el-form-item>
        <el-form-item prop="carConditionPic" :label="$t('bike.name186')">
          <div class="upload-layout">
            <el-upload
              ref="upload1"
              class="avatar-uploader"
              action=""
              accept="image/*"
              :http-request="
                (e) => {
                  handleUpLoadFile(1,e)
                }
              "
              :show-file-list="false"
            >
              <img v-if="ebikeModeForm.carConditionPic" :src="ebikeModeForm.carConditionPic" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item prop="devicePic" :label="$t('bike.name187')">
          <div class="upload-layout">
            <el-upload
              ref="upload2"
              action=""
              accept="image/*"
              class="avatar-uploader"
              :http-request="
                (e) => {
                  handleUpLoadFile(2,e)
                }
              "
              :show-file-list="false"
            >
              <img v-if="ebikeModeForm.devicePic" :src="ebikeModeForm.devicePic" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sumbit">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

       <!--导入车型-->
       <el-dialog :title="$t('bike.name189')" :visible.sync="modelUploadDialog" v-if="modelUploadDialog" :close-on-click-modal ="false" :before-close="close1" width="600px">
      <el-form label-width="150px">
        <el-form-item :label="$t('bike.name100')">
          <a :href="importVehicleModel">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name408')">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="modelFile">
          <div>{{ modelFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadSectionFile" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close1">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
  :title="$t('bike.name407')"
  :visible.sync="dialogVisible"
  width="50%"
  :before-close="handleClose">
  <el-form ref="offsetFormRef" label-width="300px"  :model="offsetForm">
    <el-form-item :label="$t('bike.name236')" prop="iotTemperatureShowDeviation">
          <el-input-number v-model="offsetForm.iotTemperatureShowDeviation" :precision="0"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('bike.name237')" prop="iotTemperatureShowWarnDefaultValue">
          <el-input-number v-model="offsetForm.iotTemperatureShowWarnDefaultValue" :precision="0"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('bike.name239')" prop="controllerTemperatureShowDeviation">
          <el-input-number v-model="offsetForm.controllerTemperatureShowDeviation" :precision="0"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('bike.name240')" prop="controllerTemperatureShowWarnDefaultValue">
          <el-input-number v-model="offsetForm.controllerTemperatureShowWarnDefaultValue" :precision="0"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('bike.name243')" prop="batteryTemperatureShowDeviation">
          <el-input-number v-model="offsetForm.batteryTemperatureShowDeviation" :precision="0"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('bike.name244')" prop="batteryTemperatureShowWarnDefaultValue">
          <el-input-number v-model="offsetForm.batteryTemperatureShowWarnDefaultValue" :precision="0"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('bike.name247')" prop="motorTemperatureShowDeviation">
          <el-input-number v-model="offsetForm.motorTemperatureShowDeviation" :precision="0"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('bike.name248')" prop="motorTemperatureShowWarnDefaultValue">
          <el-input-number v-model="offsetForm.motorTemperatureShowWarnDefaultValue" :precision="0"></el-input-number>
        </el-form-item>
  </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" :loading="loading2" @click="sumbitOffSet">{{ $t('public.name13') }}</el-button>
    <el-button @click="handleClose">{{ $t('public.name14') }}</el-button>
  </span>
</el-dialog>
  </div>
</template>
<script>
// import Cookies from 'js-cookie'
import { findEbikeModelPage, saveEbikeModel, updateEbikeModel, deleteEbikeModel, findEbikeModelDetail, importEbikeModel, downloadTempFile } from '@/api/bike.js'
import { uploadFile, tenantList } from '@/api/manage.js'
import { downloadExcel } from '@/utils/utils'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      importVehicleModel: 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E5%9E%8B-%E6%A8%A1%E6%9D%BFv4.xlsx',
      modelFile: null,
      loading2: false,
      modelUploadDialog: false,
      queryInfo: {
        pageNumber: 1,
        pageSize: 10,
        ebikeModelId: '',
        ebikeModelName: '',
        tenantId: '',
        electricalMachineryModel: '',
        batteryModel: ''
      },
      dialogVisible: false,
      offsetForm: {
        ebikeModelId: '',
        ebikeModelName: '',
        cccCode: '',
        iotTemperatureShowDeviation: -50,
        iotTemperatureShowWarnDefaultValue: 80,
        controllerTemperatureShowDeviation: -50,
        controllerTemperatureShowWarnDefaultValue: 80,
        batteryTemperatureShowDeviation: -50,
        batteryTemperatureShowWarnDefaultValue: 80,
        motorTemperatureShowDeviation: -50,
        motorTemperatureShowWarnDefaultValue: 80
      },
      tableLoading: false,
      tenantOptions: [],
      ebikeModelDialog: false,
      tableList: [],
      total: 0,
      ebikeModeForm: {
        ebikeModelId: '',
        ebikeModelName: '',
        cccCode: '',
        modelColor: '',
        iotVersionNo: '',
        iotTemperatureShowDeviation: -50,
        iotTemperatureShowWarnDefaultValue: 80,
        controllerVersion: '',
        controllerTemperatureShowDeviation: -50,
        controllerTemperatureShowWarnDefaultValue: 80,
        batteryVersion: '',
        batteryTemperatureShowDeviation: -50,
        batteryTemperatureShowWarnDefaultValue: 80,
        motorVersion: '',
        motorTemperatureShowDeviation: -50,
        motorTemperatureShowWarnDefaultValue: 80,
        meterVersion: '',
        certificateExpireDate: '',
        productCertificateNumber: '',
        productModel: '',
        certificateStatus: '',
        ebikeManufacturer: '',
        manufactureEnterpriseName: '',
        ebikeCnBrand: '',
        ebikeEnBrand: '',
        manufactureEnterpriseAddress: '',
        lengthValue: '',
        widthValue: '',
        heightValue: '',
        ebikeWeight: '',
        maxDesignSpeed: '',
        nameplateFixedPosition: '',
        ebikeFrameCodePosition: '',
        enduranceMileage: '',
        ebikeOutlinePicName: '',
        batteryType: '',
        batteryManufactureEnterpriseName: '',
        batteryCapacity: '',
        batteryModel: '',
        batteryVoltage: '',
        batteryCurrent: '',
        batteryWeight: '',
        batteryLength: '',
        batteryWidth: '',
        batteryHeight: '',
        beforeAfterWheelDistance: '',
        driveType: '',
        hundredKmPowerConsumption: '',
        motorManufactureEnterprise: '',
        electricalMachineryModel: '',
        motorType: '',
        motorRatedSpeed: '',
        motorRatedVoltage: '',
        motorRatedOutputPower: '',
        controllerManufactureEnterprise: '',
        controllerModel: '',
        controllerUndervoltageProtectionValue: '',
        controllerOvercurrentProtectionValue: '',
        frontTireSpecifications: '',
        rearTireSpecifications: '',
        executiveStandardNumber: '',
        deadweightCapacity: '',
        batteryNominalVoltage: '',
        motorNominalPower: '',
        brakeType: '',
        transmissionSpecifications: '',
        iotManufactureEnterprise: '',
        tire: '',
        sensor: '',
        carConditionPic: '',
        devicePic: ''
      },
      type: 1,
      buttonPerms: '',
      ebikeModelFormRules: {
        ebikeModelId: [
          {
            required: true,
            message: this.$t('bike.name468'),
            trigger: 'blur'
          }
        ],
        ebikeModelName: [
          {
            required: true,
            message: this.$t('bike.name474'),
            trigger: 'blur'
          }
        ],
        cccCode: [
          {
            required: true,
            message: this.$t('bike.name475'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    this.buttonPerms = localStorage.getItem('buttonPerms')
  },
  beforeDestroy() {
    this.$bus.$off('lang')
  },
  mounted() {
    this.$bus.$on('lang', (lang) => {
      if (lang === 'en') {
        this.importVehicleModel = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Import%20vehicle%20model.xlsx'
      } else {
        this.importVehicleModel = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E5%9E%8B-%E6%A8%A1%E6%9D%BFv4.xlsx'
      }
    })
    this.getEbikeModelList()
    this.getTenantList()
  },
  methods: {
    getTenantList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      tenantList(data)
        .then(res => {
          this.tenantOptions = res.data.list
        })
        .catch(() => {
          this.tableList = []
        })
    },
    getPageList() {
      this.queryInfo.pageNumber = 1
      this.queryInfo.pageSize = 10
      this.getEbikeModelList()
    },
    getEbikeModelList() {
      this.tableLoading = true
      this.queryInfo.ebikeModelId = this.queryInfo.ebikeModelId.trim()
      this.queryInfo.ebikeModelName = this.queryInfo.ebikeModelName.trim()
      this.queryInfo.electricalMachineryModel = this.queryInfo.electricalMachineryModel.trim()
      this.queryInfo.batteryModel = this.queryInfo.batteryModel.trim()
      findEbikeModelPage(this.queryInfo).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.tableList = res.data.ebikeModelPage.records
          this.total = res.data.ebikeModelPage.total
        }
      })
    },
    showAddModelDialog(row) {
      if (row === null) {
        this.type = 1
        this.ebikeModelDialog = true
      } else {
        this.type = 2
        findEbikeModelDetail({ ebikeModelId: row.ebikeModelId })
          .then((res) => {
            if (res.code === 200) {
              this.ebikeModelDialog = true
              this.ebikeModeForm = {
                ebikeModelId: res.data.detail.ebikeModelId,
                ebikeModelName: res.data.detail.ebikeModelName,
                cccCode: res.data.detail.cccCode,
                modelColor: res.data.detail.modelColor,
                iotVersionNo: res.data.detail.iotVersionNo,
                iotTemperatureShowDeviation: res.data.detail.iotTemperatureShowDeviation,
                iotTemperatureShowWarnDefaultValue: res.data.detail.iotTemperatureShowWarnDefaultValue,
                controllerVersion: res.data.detail.controllerVersion,
                controllerTemperatureShowDeviation: res.data.detail.controllerTemperatureShowDeviation,
                controllerTemperatureShowWarnDefaultValue: res.data.detail.controllerTemperatureShowWarnDefaultValue,
                batteryVersion: res.data.detail.batteryVersion,
                batteryTemperatureShowDeviation: res.data.detail.batteryTemperatureShowDeviation,
                batteryTemperatureShowWarnDefaultValue: res.data.detail.batteryTemperatureShowWarnDefaultValue,
                motorVersion: res.data.detail.motorVersion,
                motorTemperatureShowDeviation: res.data.detail.motorTemperatureShowDeviation,
                motorTemperatureShowWarnDefaultValue: res.data.detail.motorTemperatureShowWarnDefaultValue,
                meterVersion: res.data.detail.meterVersion,
                certificateExpireDate: res.data.detail.certificateExpireDate,
                productCertificateNumber: res.data.detail.productCertificateNumber,
                productModel: res.data.detail.productModel,
                certificateStatus: res.data.detail.certificateStatus,
                ebikeManufacturer: res.data.detail.ebikeManufacturer,
                manufactureEnterpriseName: res.data.detail.manufactureEnterpriseName,
                ebikeCnBrand: res.data.detail.ebikeCnBrand,
                ebikeEnBrand: res.data.detail.ebikeEnBrand,
                manufactureEnterpriseAddress: res.data.detail.manufactureEnterpriseAddress,
                lengthValue: res.data.detail.lengthValue,
                widthValue: res.data.detail.widthValue,
                heightValue: res.data.detail.heightValue,
                ebikeWeight: res.data.detail.ebikeWeight,
                maxDesignSpeed: res.data.detail.maxDesignSpeed,
                nameplateFixedPosition: res.data.detail.nameplateFixedPosition,
                ebikeFrameCodePosition: res.data.detail.ebikeFrameCodePosition,
                enduranceMileage: res.data.detail.enduranceMileage,
                ebikeOutlinePicName: res.data.detail.ebikeOutlinePicName,
                batteryType: res.data.detail.batteryType,
                batteryManufactureEnterpriseName: res.data.detail.batteryManufactureEnterpriseName,
                batteryCapacity: res.data.detail.batteryCapacity,
                batteryModel: res.data.detail.batteryModel,
                batteryVoltage: res.data.detail.batteryVoltage,
                batteryCurrent: res.data.detail.batteryCurrent,
                batteryWeight: res.data.detail.batteryWeight,
                batteryLength: res.data.detail.batteryLength,
                batteryWidth: res.data.detail.batteryWidth,
                batteryHeight: res.data.detail.batteryHeight,
                beforeAfterWheelDistance: res.data.detail.beforeAfterWheelDistance,
                driveType: res.data.detail.driveType,
                hundredKmPowerConsumption: res.data.detail.hundredKmPowerConsumption,
                motorManufactureEnterprise: res.data.detail.motorManufactureEnterprise,
                electricalMachineryModel: res.data.detail.electricalMachineryModel,
                motorType: res.data.detail.motorType,
                motorRatedSpeed: res.data.detail.motorRatedSpeed,
                motorRatedVoltage: res.data.detail.motorRatedVoltage,
                motorRatedOutputPower: res.data.detail.motorRatedOutputPower,
                controllerManufactureEnterprise: res.data.detail.controllerManufactureEnterprise,
                controllerModel: res.data.detail.controllerModel,
                controllerUndervoltageProtectionValue: res.data.detail.controllerUndervoltageProtectionValue,
                controllerOvercurrentProtectionValue: res.data.detail.controllerOvercurrentProtectionValue,
                frontTireSpecifications: res.data.detail.frontTireSpecifications,
                rearTireSpecifications: res.data.detail.rearTireSpecifications,
                executiveStandardNumber: res.data.detail.executiveStandardNumber,
                deadweightCapacity: res.data.detail.deadweightCapacity,
                batteryNominalVoltage: res.data.detail.batteryNominalVoltage,
                motorNominalPower: res.data.detail.motorNominalPower,
                brakeType: res.data.detail.brakeType,
                transmissionSpecifications: res.data.detail.transmissionSpecifications,
                iotManufactureEnterprise: res.data.detail.iotManufactureEnterprise,
                tire: res.data.detail.tire,
                sensor: res.data.detail.sensor,
                carConditionPic: res.data.detail.carConditionPic.length > 0 ? res.data.detail.carConditionPic[0].address : '',
                devicePic: res.data.detail.devicePic.length > 0 ? res.data.detail.devicePic[0].address : ''
              }
            }
          })
          .catch(() => {})
      }
    },
    sumbit() {
      this.$refs.ebikeModelFormRef.validate(valid => {
        if (valid) {
          this.loading = true
          if (!Array.isArray(this.ebikeModeForm.carConditionPic)) {
            this.ebikeModeForm.carConditionPic = [{ address: this.ebikeModeForm.carConditionPic, type: 0 }]
          }
          if (!Array.isArray(this.ebikeModeForm.devicePic)) {
            this.ebikeModeForm.devicePic = [{ address: this.ebikeModeForm.devicePic, type: 1 }]
          }
          if (this.type === 1) {
            saveEbikeModel(this.ebikeModeForm).then(res => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.getEbikeModelList()
              }
            }).catch(() => {
              this.loading = false
            })
          } else {
            updateEbikeModel(this.ebikeModeForm).then(res => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.getEbikeModelList()
              }
            }).catch(() => {
              this.loading = false
            })
          }
        } else {
          return false
        }
      })
    },

    delModel(row) {
      this.$confirm(this.$t('public.name40'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          deleteEbikeModel({ ebikeModelId: row.ebikeModelId }).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: this.$t('public.name30')
              })
              this.queryInfo.pageNumber = 1
              this.getEbikeModelList()
            }
          }).catch(() => {})
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },
    close() {
      this.ebikeModelDialog = false
      this.ebikeModeForm = {
        ebikeModelId: '',
        ebikeModelName: '',
        cccCode: '',
        modelColor: '',
        iotVersionNo: '',
        iotTemperatureShowDeviation: -50,
        iotTemperatureShowWarnDefaultValue: 80,
        controllerVersion: '',
        controllerTemperatureShowDeviation: -50,
        controllerTemperatureShowWarnDefaultValue: 80,
        batteryVersion: '',
        batteryTemperatureShowDeviation: -50,
        batteryTemperatureShowWarnDefaultValue: 80,
        motorVersion: '',
        motorTemperatureShowDeviation: -50,
        motorTemperatureShowWarnDefaultValue: 80,
        meterVersion: '',
        certificateExpireDate: '',
        productCertificateNumber: '',
        productModel: '',
        certificateStatus: '',
        ebikeManufacturer: '',
        manufactureEnterpriseName: '',
        ebikeCnBrand: '',
        ebikeEnBrand: '',
        manufactureEnterpriseAddress: '',
        lengthValue: '',
        widthValue: '',
        heightValue: '',
        ebikeWeight: '',
        maxDesignSpeed: '',
        nameplateFixedPosition: '',
        ebikeFrameCodePosition: '',
        enduranceMileage: '',
        ebikeOutlinePicName: '',
        batteryType: '',
        batteryManufactureEnterpriseName: '',
        batteryCapacity: '',
        batteryModel: '',
        batteryVoltage: '',
        batteryCurrent: '',
        batteryWeight: '',
        batteryLength: '',
        batteryWidth: '',
        batteryHeight: '',
        beforeAfterWheelDistance: '',
        driveType: '',
        hundredKmPowerConsumption: '',
        motorManufactureEnterprise: '',
        electricalMachineryModel: '',
        motorType: '',
        motorRatedSpeed: '',
        motorRatedVoltage: '',
        motorRatedOutputPower: '',
        controllerManufactureEnterprise: '',
        controllerModel: '',
        controllerUndervoltageProtectionValue: '',
        controllerOvercurrentProtectionValue: '',
        frontTireSpecifications: '',
        rearTireSpecifications: '',
        executiveStandardNumber: '',
        deadweightCapacity: '',
        batteryNominalVoltage: '',
        motorNominalPower: '',
        brakeType: '',
        transmissionSpecifications: '',
        iotManufactureEnterprise: '',
        tire: '',
        sensor: '',
        carConditionPic: '',
        devicePic: ''
      }
    },
    resetQuery() {
      this.queryInfo = {
        pageNumber: 1,
        pageSize: 10,
        ebikeModelId: '',
        ebikeModelName: '',
        tenantId: '',
        electricalMachineryModel: '',
        batteryModel: ''
      }
      this.getEbikeModelList()
    },
    handleUpLoadFile(type, param) {
      console.log('===', type)
      const formData = new FormData()
      formData.append('multipart', param.file)
      const loading = this.$loading({
        lock: true,
        text: this.$t('public.name35'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      uploadFile(formData)
        .then(res => {
          loading.close()
          if (res.code === 200) {
            if (type === 1) {
              this.ebikeModeForm.carConditionPic = res.data.fileUrl
            } else {
              this.ebikeModeForm.devicePic = res.data.fileUrl
            }
            this.$message.success(this.$t('public.name42'))
          }
        })
        .catch(res => {
          loading.close()
        })
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getEbikeModelList()
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.getEbikeModelList()
    },
    delFile() {
      this.modelFile = null
    },
    handleBeforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error(this.$t('public.name36'))
        return false
      }
      return true
    },
    handleManualUpload() {
      this.$refs.fileInput.click()
    },
    handleFileChange(e) {
      this.modelFile = e.target.files[0]
      e.target.value = ''
    },
    close1() {
      this.modelUploadDialog = false
      this.modelFile = null
    },
    importModelDialog() {
      this.modelUploadDialog = true
    },
    uploadSectionFile() {
      if (this.modelFile === null) {
        return
      }
      const formData = new FormData()
      formData.append('file', this.modelFile)
      this.loading2 = true
      importEbikeModel(formData)
        .then(res => {
          this.loading2 = false
          if (res.code === 200) {
            if (res.data) {
              downloadTempFile({ objectName: res.data })
                .then((res) => {
                  this.$confirm(this.$t('public.name46'), this.$t('public.name23'), {
                    confirmButtonText: this.$t('public.name37'),
                    cancelButtonText: this.$t('public.name14'),
                    type: 'warning'
                  })
                    .then(() => {
                      downloadExcel(res, this.$t('public.name47'))
                    })
                    .catch(() => {})
                })
                .catch((res) => {})
            } else {
              this.$message.success(this.$t('public.name48'))
            }
          }
          this.getPageList()
          this.close1()
        })
        .catch(res => {
          this.loading2 = false
        })
    },
    showOffsetDialog(row) {
      this.offsetForm = {
        ebikeModelId: row.ebikeModelId,
        ebikeModelName: row.ebikeModelName,
        cccCode: row.cccCode,
        iotTemperatureShowDeviation: row.iotTemperatureShowDeviation,
        iotTemperatureShowWarnDefaultValue: row.iotTemperatureShowWarnDefaultValue,
        controllerTemperatureShowDeviation: row.controllerTemperatureShowDeviation,
        controllerTemperatureShowWarnDefaultValue: row.controllerTemperatureShowWarnDefaultValue,
        batteryTemperatureShowDeviation: row.batteryTemperatureShowDeviation,
        batteryTemperatureShowWarnDefaultValue: row.batteryTemperatureShowWarnDefaultValue,
        motorTemperatureShowDeviation: row.motorTemperatureShowDeviation,
        motorTemperatureShowWarnDefaultValue: row.motorTemperatureShowWarnDefaultValue
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    sumbitOffSet() {
      this.loading = true
      updateEbikeModel(this.offsetForm).then(res => {
        this.loading2 = false
        if (res.code === 200) {
          this.handleClose()
          this.getEbikeModelList()
        }
      }).catch(() => {
        this.loading2 = false
      })
    }
  }
}
</script>
<style lang="scss">
.el-input-number{
  line-height: 33px !important;
}
.mode-dialog{
  .el-dialog{
  margin-top: 8vh !important;
}
.el-dialog__body{
  height: 65vh;
  overflow: auto;
}
}
</style>
<style lang="scss" scoped>
.modellist-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .upload-layout {
    display: flex;
    flex-direction: row;
    align-items: center;

    .avatar {
      width: 50px;
      height: 50px;
    }
    > :last-child {
      margin-left: 10px;
      font-size: 12px;
      color: #555;
      line-height: 16.8px;
    }
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  width: 178px;
  height: 178px;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.file-list{
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-top: -25px;

    .el-icon-close{
      font-size: 18px;
    }
  }
</style>
